import { useState } from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Collapse from "@mui/material/Collapse";
import type { SiteListItem } from "./useSiteList";
import { COLSPAN_FULL } from "./SiteDataGrid";
import { CredentialsSubTable } from "./CredentialsSubTable";
import { formatDate } from "../../lib/FormatDate";
import { renderPluginStatus } from "./RenderPluginStatus";
import { renderSiteType } from "./RenderSiteType";

export function SiteRow(props: {
  item: SiteListItem;
  selected: boolean;
  onToggle: () => void;
}) {
  const { item, selected, onToggle } = props;
  const [expanded, setExpanded] = useState(false);
  const hasCredentials = item.credentials !== null && item.credentials.length > 0;

  return (
    <>
      <TableRow hover>
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onChange={onToggle} />
        </TableCell>
        <TableCell padding="none" sx={{ width: 40 }}>
          {hasCredentials && (
            <IconButton size="small" onClick={() => setExpanded(!expanded)}>
              {expanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCell>
        <TableCell>{item.url}</TableCell>
        <TableCell>{item.region}</TableCell>
        <TableCell>{renderSiteType(item.siteType)}</TableCell>
        <TableCell>{item.seller}</TableCell>
        <TableCell align="right">{item.dr ?? "—"}</TableCell>
        <TableCell align="right">{item.organicKeywords ?? "—"}</TableCell>
        <TableCell align="right">{item.age ?? "—"}</TableCell>
        <TableCell className="tabular-nums" align="right">{item.credentialCount}</TableCell>
        <TableCell className="tabular-nums" align="right">{item.validChannelCount}</TableCell>
        <TableCell align="center">{renderPluginStatus(item.pluginArticleStatus)}</TableCell>
        <TableCell align="center">{renderPluginStatus(item.pluginHomepageStatus)}</TableCell>
        <TableCell align="center">{renderPluginStatus(item.pluginSitewideStatus)}</TableCell>
        <TableCell align="center">{renderPluginStatus(item.pluginLinkRemovalStatus)}</TableCell>
        <TableCell className="tabular-nums" align="right">{item.articlePostsCount}</TableCell>
        <TableCell className="tabular-nums" align="right">{item.homepagePostsCount}</TableCell>
        <TableCell align="right">{item.articleAttemptErrors}</TableCell>
        <TableCell align="right">{item.homepageAttemptErrors}</TableCell>
        <TableCell>{formatDate(item.lastArticlePublishedAt)}</TableCell>
        <TableCell>{formatDate(item.lastHomepagePublishedAt)}</TableCell>
        <TableCell>{formatDate(item.lastSitewidePublishedAt)}</TableCell>
        <TableCell>{formatDate(item.lastCheckedAt)}</TableCell>
        <TableCell>{formatDate(item.createdAt)}</TableCell>
      </TableRow>
      {hasCredentials && (
        <TableRow>
          <TableCell colSpan={COLSPAN_FULL} sx={{ py: 0, borderBottom: expanded ? undefined : "none" }}>
            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <CredentialsSubTable credentials={item.credentials} />
            </Collapse>
          </TableCell>
        </TableRow>
      )}
    </>
  );
}
